import React from "react";
import srichakra from "../Assests/namboothiri1.jpeg";
import lotus from "../Assests/namboothrichan.jpeg";
import "../Styles/About.css";

function About() {
  return (
    <div className="about-page">
      {/* SECTION 1 */}
      <section className="about-section">
        <div className="container">
          <h2 className="section-title">Puliyampilly Nambooriyachan</h2>
          
          <div className="section-content clearfix">
            <div className="float-img-left">
              <img
                src={lotus}
                alt="Puliyampilly Namboothiri Achan"
                className="about-image shadow"
              />
            </div>

            <p>
              <strong>The Story of Puliyampilly Namboothiri</strong>
              <br />
              Many centuries ago, there lived a Namboothiri named Puliyampilly
              Namboothiri, a great devotee of Bhadrakali Devi. He was not an
              ordinary priest but a powerful Tantric practitioner (Mantravadi)
              who spent years performing severe penance and worship.Every midnight, after everyone in the village had gone to sleep,
              he would enter his sacred worship room and perform secret rituals dedicated to Bhadrakali. His worship differed from the
              usual Vedic rituals. According to the legend, he used offerings
              such as meat and liquor that were prescribed in certain Tantric
              traditions.The other Namboothiris became suspicious. They believed he was
              secretly drinking alcohol and violating Brahmin customs. They
              decided to expose him. One night they entered his house while he was away and found a
              large covered pot. They were convinced it contained liquor. When
              Puliyampilly Namboothiri returned, they demanded that he open
              the pot. He calmly removed the lid. To everyone's surprise, the
              pot contained only dried areca nuts (adakka/gante). There was no
              trace of liquor. The visitors were embarrassed and left. After they departed, tradition says that the contents returned to
              the ritual substance required for his worship through the grace of
              Bhadrakali, showing that the Goddess herself protected her
              devotee.
            </p>
            <p>
              Although many now respected him, some still doubted his spiritual
              powers. The local ruler challenged him to demonstrate that his
              powers truly came from the Goddess. Puliyampilly Namboothiri
              accepted. He asked the king to come outside on the night of
              Amavasya, when there should be no moon in the sky. After
              performing intense prayers to Bhadrakali, he asked the king to
              look upward.The king was astonished. Instead of darkness, two radiant full
              moons appeared in the sky. The ruler and everyone present bowed
              before Puliyampilly Namboothiri, recognizing him as a great
              Bhadrakali Upāsakar. This miracle became one of the best-known
              legends associated with him.
            </p>
            <p>
             
              The legend says that Puliyampilly Namboothiri dedicated his life to
              helping devotees through the blessings of Bhadrakali. His name
              continues to be associated with hereditary shrines where
              Bhadrakali and Vishnumaya are worshipped, and rituals such as
              Guruthi, Chenkuruthi, and Karinkuruthi are still performed
              according to that tradition.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 2 */}
      <section className="goddess-section">
        <div className="container">
          <h2 className="section-title">Temple History</h2>
          
          <div className="section-content clearfix">
            <div className="float-img-right">
              <img
                src={srichakra}
                alt="Bhadrakali Temple Shrine"
                className="goddess-img shadow"
              />
            </div>

            <p>
              This temple is an ancient and revered shrine located in North
              Paravoor, Ernakulam District, Kerala. The temple stands uniquely
              at the center of a four-way road junction, where vehicles pass
              around it from all directions throughout the day. Beneath the
              shelter of a majestic banyan tree, the sacred shrine is enclosed by
              a simple four-foot-high circular cement structure.
            </p>
            <p>
              Despite its modest appearance and its location amidst the busy
              traffic, the temple radiates an extraordinary divine presence
              (Chaithanyam).
            </p>

            <div className="highlight-text">
              It is believed that the spirit of Puliyampilli Namboothiri
              resides in this banyan tree. There is no evil spirit that will not
              leave if Puliyampilly exorcises it, so great and severe was his
              worship of Goddess Bhadrakali.
               For Puliyampilly, Bhadrakali was a manifest deity in person. It
              was from this Althara (the platform of the banyan tree) that people
              from different regions used to take Puliyampilly, who was a
              Shaktheya worshipper, for exorcising evil spirits and for other
              sorcery rituals. It is believed that he spent a major part of his
              life resting under this banyan tree.
           

            <p>
          "Elders recount that whenever he set out for worship, Goddess Bhadrakali walked beside him as a small child, gently
           holding his hand." For generations, devotees have visited this sacred
              place with unwavering faith, believing that Goddess Bhadrakali
              listens to their prayers and showers them with protection,
              strength, and blessings.
            </p>
 </div>
            {/* References Section */}
            <div className="references-block mt-4">
              <p className="mb-1">
                <strong>References</strong>
              </p>
              <p className="mb-1">
                Aithihyamala (ഐതിഹ്യമാല) | Kottarathil Sankunni
              </p>
              <p className="mb-1">
                The Visva Vijnana Kosham (വിശ്വ വിജ്ഞാന കോശം) by Sahithya
                Pravarthaka Co-Operative Society (SPCS)-Kottayam 1972
              </p>
              <p className="mb-1">
                Keralathile Sthalacharithrangal- Ernakulam Jilla (കേരളത്തിലെ
                സ്ഥലചരിത്രങ്ങൾ - എറണാകുളം ജില്ല) by V.V.K. VALATH
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;